import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import {
  LocationAllowedOsUpdateReducer,
  LocationAllowedOsUpdateFeatureKey,
} from './location-allowed-os-updates.reducer';
import { LocationAllowedOsUpdateEffects } from './location-allowed-os-updates.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(LocationAllowedOsUpdateFeatureKey, LocationAllowedOsUpdateReducer),
    EffectsModule.forFeature([LocationAllowedOsUpdateEffects]),
  ],
  providers: [],
})
export class LocationAllowedOsUpdateStoreModule {}
